<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-app-bar app color="primary" dark height="88">
      <div class="d-flex align-center flex-shrink-0">
        <v-img
          alt="VendorProof Logo"
          height="25"
          width="245"
          class="mr-12"
          contain
          src="@/assets/logo-2x.png"
          transition="scale-transition"
        />
      </div>
    </v-app-bar>
    <v-container class="pt-6">
      <loading-overlay :value="loading" />
      <v-stepper v-model="currentStep">
        <div class="text-center mt-2 header">Vendor Set-Up</div>
        <v-stepper-header class="mb-2">
          <v-stepper-step
            :complete="currentStep > 1"
            step="1"
            class="left-header"
          >
            Profile Information
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="false" step="2" class="right-header">
            Vendor Information
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="pa-0">
            <foldable-card
              class="pt-3 mb-12"
              color="grey lighten-1"
              height="200px"
              non-foldable
              title="Profile Information"
              disable-header-divider
            >
              <template v-slot:description>
                <p class="text-center description">
                  Please enter your name and contact information.
                </p>
                <v-divider></v-divider>
              </template>
              <v-card-text class="pa-0">
                <v-form v-model="form1Valid">
                  <v-container pa-0>
                    <v-row no-gutters class="mt-1 mb-2">
                      <v-col cols="2">
                        <div class="information-container-title">
                          First Name
                        </div>
                      </v-col>
                      <v-col cols="7">
                        <v-text-field
                          filled
                          dense
                          class="first-name"
                          v-model="vm.userFirstName"
                          :rules="[rules.required('First Name')]"
                          label="First Name"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider />

                    <v-row no-gutters class="mt-8 mb-2">
                      <v-col cols="2">
                        <div class="information-container-title">
                          Last Name
                        </div>
                      </v-col>
                      <v-col cols="7">
                        <v-text-field
                          filled
                          dense
                          v-model="vm.userLastName"
                          :rules="[rules.required('Last Name')]"
                          label="Last Name"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row no-gutters class="mt-8 mb-2">
                      <v-col cols="2">
                        <div class="information-container-title">
                          Phone Number
                        </div>
                      </v-col>
                      <v-col cols="7">
                        <v-text-field
                          filled
                          dense
                          v-model="vm.userPhoneNumber"
                          v-mask="mask"
                          placeholder="000-000-0000"
                          :rules="[
                            rules.required('Phone Number'),
                            rules.phoneNumber
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row no-gutters class="mt-8 mb-2">
                      <v-col cols="2">
                        <div class="information-container-title">
                          Email
                        </div>
                      </v-col>
                      <v-col cols="7">
                        <v-text-field
                          filled
                          dense
                          v-model="vm.userEmail"
                          label="email@yahoo.com"
                          :rules="[rules.required('Email'), rules.email]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row no-gutters class="mt-8 mb-2">
                      <v-col cols="2">
                        <div class="information-container-title">
                          Facility
                        </div>
                      </v-col>
                      <v-col cols="7">
                        <v-autocomplete
                          filled
                          dense
                          v-model="vm.covManagerId"
                          :items="facilities"
                          item-value="id"
                          item-text="name"
                          placeholder="Please Select"
                          :rules="[rules.required('Facility')]"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <div class="note-text">
                      Note: This information will only be used internally in the
                      event there are any questions or issues with the vendor
                      being set up
                    </div>
                    <v-row class="mt-8 mx-10">
                      <v-spacer />
                      <v-btn
                        color="primary"
                        @click="currentStep = 2"
                        :disabled="!form1Valid"
                      >
                        Next
                        <v-icon class="ml-2 mr-n1">mdi-chevron-right</v-icon>
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
            </foldable-card>
          </v-stepper-content>

          <v-stepper-content step="2" class="pa-0">
            <foldable-card
              class="pt-3 mb-12 px-10"
              color="grey lighten-1"
              height="200px"
              non-foldable
              title="Vendor Information"
              disable-header-divider
            >
              <template v-slot:description>
                <p class="text-center description">
                  Please enter vendor information here.
                </p>
                <v-divider></v-divider>
              </template>
              <v-card-text class="pa-0">
                <v-form v-model="form2Valid">
                  <v-container class="pa-0">
                    <v-row no-gutters class="mt-1 mb-2">
                      <v-col cols="2">
                        <div class="information-container-title">
                          Business Name
                        </div>
                      </v-col>
                      <v-col cols="7">
                        <v-text-field
                          filled
                          dense
                          v-model="vm.covBusinessName"
                          :rules="[rules.required('Business Name')]"
                          label="Business Name"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row no-gutters class="mt-8 mb-2">
                      <v-col cols="2">
                        <div class="information-container-title">
                          Email
                        </div>
                      </v-col>
                      <v-col cols="7">
                        <v-text-field
                          filled
                          dense
                          v-model="vm.covEmail"
                          :rules="[rules.required('Email'), rules.email]"
                          label="Email"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row no-gutters class="mt-8 mb-2">
                      <v-col cols="2">
                        <div class="information-container-title">
                          Phone Number
                        </div>
                      </v-col>
                      <v-col cols="7">
                        <v-text-field
                          filled
                          dense
                          v-model="vm.covPhoneNumber"
                          v-mask="mask"
                          placeholder="000-000-0000"
                          :rules="[
                            rules.required('Phone Number'),
                            rules.phoneNumber
                          ]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider />

                    <v-row no-gutters class="mt-8 mb-2">
                      <v-col cols="2">
                        <div class="information-container-title">
                          Vendor Category
                        </div>
                      </v-col>
                      <v-col cols="7">
                        <v-autocomplete
                          filled
                          dense
                          v-model="vm.covVendorCategoryId"
                          :items="vendorCategories"
                          :rules="[rules.required('Vendor Category')]"
                          placeholder="Please Select"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>

                    <v-row no-gutters class="mt-8 mb-2">
                      <v-col offset="2" cols="7">
                        <div :id="captcha.id" />
                      </v-col>
                    </v-row>

                    <v-row class="pt-8 mt-8 mx-1">
                      <v-btn @click="currentStep = 1">
                        <v-icon left>mdi-chevron-left</v-icon>
                        Back
                      </v-btn>
                      <v-spacer />
                      <v-btn
                        color="colorVpDarkGreen"
                        class="white--text px-8"
                        @click="save()"
                        :disabled="!form2Valid"
                        :loading="loading"
                      >
                        Submit
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
            </foldable-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import FoldableCard from "@/components/FoldableCard";
import * as rules from "@/services/rules";
import { get, post } from "@/services/request";
import {
  clientForPurlAPI,
  subclientsForParentPurlAPI,
  vendorCategoryAPI,
  simpleCovAPI
} from "@/services/api";
import hasNotifications from "@/mixins/has-notifications";
import LoadingOverlay from "@/components/LoadingOverlay";
import { renderCaptcha } from "@/services/captcha";

export default {
  mixins: [hasNotifications],
  directives: {
    mask
  },
  beforeRouteEnter: (to, from, next) => {
    get(clientForPurlAPI.getUrl(to.params.clientTag))
      .then(response => {
        to.params.clientData = response && response.data;
        next();
      })
      .catch(e => {
        if (e && e.response && e.response.status === 404) {
          window.location.href = "/error-notfound";
        } else {
          next();
        }
      });
  },
  data: function() {
    return {
      vm: {
        userFirstName: null,
        userLastName: null,
        userPhoneNumber: null,
        userEmail: null,
        covManagerId: null,
        covBusinessName: null,
        covEmail: null,
        covPhoneNumber: null,
        covVendorCategoryId: null
      },
      mask: "###-###-####",
      currentStep: 1,
      rules,
      facilities: [],
      vendorCategories: [],
      loading: false,
      form1Valid: false,
      form2Valid: false,
      captcha: {
        id: "vendorSetup",
        token: null
      }
    };
  },
  name: "simpleVendorSetup",
  props: {
    clientTag: {
      type: String
    }
  },
  components: {
    LoadingOverlay,
    FoldableCard
  },
  created() {
    this.logEvent("Landed on Simple Vendor Setup Page");

    this.loading = true;
    Promise.all([
      this.populateFacilityDropdown(this.clientTag),
      this.loadVendorCategories()
    ]).finally(() => (this.loading = false));
  },
  mounted() {
    renderCaptcha(this.captcha);
  },
  methods: {
    loadVendorCategories() {
      return get(vendorCategoryAPI.getUrl(this.clientTag))
        .then(response => {
          if (response && response.data) {
            this.vendorCategories = response.data;
          }
        })
        .catch(error => {
          this.showMessage({
            text:
              "Error getting vendor categories, please try again or contact us for help",
            mode: "error"
          });
          console.error("Error getting vendor categories", error);
        });
    },
    populateFacilityDropdown(clientTag) {
      let clientData = this.$route.params.clientData;
      if (!clientData) {
        this.showMessage({
          text:
            "Error getting corporate facility data, please try again or contact us for help",
          mode: "error"
        });
      }

      if (clientData) {
        const parentClient = clientData;
        parentClient.name = `[${parentClient.name}] - Corporate`;
        this.facilities.unshift(parentClient);
      }

      const subclientsPromise = get(
        subclientsForParentPurlAPI.getUrl(clientTag)
      )
        .then(response => {
          if (response && response.data) {
            this.facilities = this.facilities.concat(response.data);
          }
        })
        .catch(() => {
          this.showMessage({
            text:
              "Error getting facility data, please try again or contact us for help",
            mode: "error"
          });
        });

      return subclientsPromise;
    },
    save() {
      this.loading = true;
      post(simpleCovAPI, {
        ...this.vm,
        captchaToken: this.captcha.token
      })
        .then(response => {
          if (response) {
            this.$router.push({
              path: `/vendor-setup-confirmation/${this.clientTag}`
            });
          }
        })
        .catch(error => {
          if (error.response.data && error.response.data !== "") {
            this.showMessage({
              text: error.response.data,
              mode: "error"
            });
          } else {
            this.showMessage({
              text:
                "Error adding vendor, please try again or contact us for support",
              mode: "error"
            });
          }
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style lang="sass" scoped>

.foldable-card.theme--light.v-card
  margin-bottom: 0 !important

.v-stepper ::v-deep
  .v-stepper__header
    box-shadow: none

.header
  font-weight: bold
  font-size: 28px
  line-height: 35px
  color: $darker-grey

.v-stepper
  ::v-deep.v-stepper__label
    font-size: 22px
    line-height: 28px

  ::v-deep.v-stepper__step__step
    font-size: 20px
    height: 36px
    width: 36px

  .information-container-title
    font-weight: 600
    font-size: 18px
    line-height: 23px
    color: $darker-grey

    &:after
      content:" *"
      color: red

  .description
    font-size: 20px
    line-height: 25px
    color: $darker-grey

  .title
    font-weight: bold !important
    font-size: 24px !important
    line-height: 30px !important
    color: $darker-grey !important

  .theme--light.v-card > .v-card__text .note-text
    font-style: italic
    font-weight: 600
    font-size: 16px
    line-height: 20px
    color: $color-alert-red !important

  .left-header
    margin-left: 48px

  .right-header
    margin-right: 48px

  ::v-deep .v-select__slot input
    text-overflow: ellipsis

.foldable-card.v-card
    ::v-deep h3
      font-size: 24px
</style>
